module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/consultar-vlan/consultar-vlan.component.css
// module id = ./src/app/consultar-vlan/consultar-vlan.component.css
// module chunks = main